export default __webpack_public_path__ + "static/media/3.1a73203f.jpg";